"use client";

import { useEffect } from "react";

import { preloadSiteData } from "@/lib/site-data";

const INTERACTIONS = ["pointerdown", "pointermove", "keydown", "touchstart", "scroll"] as const;

export function SiteDataPreload() {
  useEffect(() => {
    const start = () => {
      INTERACTIONS.forEach((event) => window.removeEventListener(event, start));
      preloadSiteData();
    };
    INTERACTIONS.forEach((event) =>
      window.addEventListener(event, start, { once: true, passive: true }),
    );
    return () => INTERACTIONS.forEach((event) => window.removeEventListener(event, start));
  }, []);

  return null;
}
